import { useEffect, useState } from "react";
import CreateDepartment from "./createdepartment";
import { useNavigate } from "react-router-dom";


export default function Departments() {
    const [departments, setDepartments] = useState([]);
  const [managers, setManagers] = useState([]);
  const [openDepartment, setOpenDepartment] = useState(false);

  const Navigate = useNavigate();

  const cardClassName = 'rounded-2xl border border-indigo-200/60 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 p-4 sm:p-6 shadow-[0_12px_30px_rgba(99,102,241,0.2)] backdrop-blur-xl';
  const selectClassName = 'w-full appearance-none rounded-xl border border-indigo-200/70 bg-white/90 py-2 pl-3 pr-8 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-200';


  const fetchDepartments = async () => {
    try {
      const response = await fetch("https://api.insightos.co.uk/api/getdepartments", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Departments:", data.data);
      console.log("Managers:", data.managers);

      // Save departments and managers into state
      setDepartments(data.data);
      setManagers(data.managers);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  /// send to update department manager endpoint
  const handleManagerChange = async (departmentId, selectedManagerId, number) => {

    try {
      const response = await fetch("https://api.insightos.co.uk/api/updatedepartmentmanager", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

        body: JSON.stringify({
          id:departmentId,
          Name:selectedManagerId,
          number
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Updated department manager:", data);
      fetchDepartments();
    } catch (error) {
      console.error(error);
    }
  };

  /// send to update MaxOnLeave endpoint
  const handleMaxOnLeaveChange = async (departmentId, maxOnLeaveValue) => {

    try {
      const response = await fetch("https://api.insightos.co.uk/api/updatemaxonleave", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

        body: JSON.stringify({
          id: departmentId,
          MaxOnLeave: parseInt(maxOnLeaveValue)
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Updated MaxOnLeave:", data);
      fetchDepartments(); // Refresh the data to show updated value
    } catch (error) {
      console.error(error);
    }
  };


  const handleDeleteTeam = async (departmentId) => {
    try {
      const response = await fetch(`https://api.insightos.co.uk/api/deletedepartment/${departmentId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Deleted department:", data);
      fetchDepartments();
    } catch (error) {
      console.error(error);
    }
  }







  

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-6">
      <div className={cardClassName}>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-indigo-950">Teams</h1>
          <p className="mt-2 text-sm text-indigo-900/80">
            A list of all Teams and their Managers.
          </p>
        </div>
        <button
          onClick={() => setOpenDepartment(true)}
          type="button"
          className="block mt-2 rounded-xl bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 border border-white/15 px-4 py-2 text-center text-sm font-semibold text-white shadow-lg shadow-indigo-950/40 hover:from-indigo-800/95 hover:to-indigo-600/95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Create Team 
        </button>
        <button 
          onClick={() => Navigate('/team-members')}
          type="button"
          className="block ml-5 mt-2 rounded-xl bg-gradient-to-br from-emerald-600/90 to-emerald-500/90 border border-white/15 px-4 py-2 text-center text-sm font-semibold text-white shadow-lg shadow-emerald-900/35 hover:from-emerald-500/95 hover:to-emerald-400/95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Edit Team 
        </button>

      </div>
      </div>
      <div className="mt-8 flow-root">
        {openDepartment && (
          <CreateDepartment setOpenDepartment={setOpenDepartment} />
        )}
        <div className={cardClassName}>
          <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full border-separate border-spacing-y-3">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="py-2 pl-4 pr-3 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-indigo-700/80 sm:pl-6 lg:pl-8"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-indigo-700/80"
                  >
                    Manager
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-indigo-700/80"
                  >
                    Senior Manager
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-indigo-700/80"
                  >
                    Role
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-indigo-700/80"
                  >
                    Staff
                  </th>
                   <th
                    scope="col"
                    className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-indigo-700/80"
                  >
                    Max Staff On Leave
                  </th>
                  <th
                    scope="col"
                    className="relative py-2 pl-3 pr-4 sm:pr-6 lg:pr-8"
                  >
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {departments.map((department) => (
                  <tr key={department.id || department.Name} className="bg-white/95 shadow-sm ring-1 ring-indigo-100 transition-all hover:ring-indigo-200">
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8 rounded-l-xl">
                      {department.Name}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {department.Manager}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {department.ReportsTo}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {department.Roles}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {department.staff &&
                        department.staff
                          .map((staff) => staff.Name)
                          .join(", ")}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <div className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {department.MaxOnLeave}
                      <input type="number" min="0" max={department.staff ? department.staff.length : 0} value={department.MaxOnLeave}
                        onChange={(e) => handleMaxOnLeaveChange(department.id, e.target.value)}
                        className="ml-2 w-16 rounded-lg border border-indigo-200 px-2 py-1"
                      />
                      </div>
                    </td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 lg:pr-8 rounded-r-xl">
                      <div className="flex justify-end space-x-3">
                        {/* Manager dropdown */}
                        <div>
                          <label
                            htmlFor={`manager-${department.id}`}
                            className="block text-sm font-medium text-gray-900"
                          >
                            Select Manager
                          </label>
                          <div className="mt-2">
                            <select
                              id={`manager-${department.id}`}
                              name="manager"
                              defaultValue=""
                              className={selectClassName}
                              onChange={(e) =>
                                handleManagerChange(department.id, e.target.value, 1)
                              }
                            >
                              <option value="" disabled>
                                Choose Manager
                              </option>
                              {managers
                                .filter(
                                  (manager) =>
                                    manager.Department === department.Name
                                )
                                .map((manager) => (
                                  <option key={manager.id} value={manager.Name}>
                                    {manager.Name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        {/* Senior Manager dropdown */}
                        <div>
                          <label
                            htmlFor={`seniorManager-${department.id}`}
                            className="block text-sm font-medium text-gray-900"
                          >
                            Select Senior Manager
                          </label>
                          <div className="mt-2">
                            <select
                              id={`seniorManager-${department.id}`}
                              name="seniorManager"
                              defaultValue=""
                              className={selectClassName}
                              onChange={(e) =>
                                handleManagerChange(department.id, e.target.value, 0)
                              }
                            >
                              <option value="" disabled>
                                Choose Senior Manager
                              </option>
                              {managers
                                .filter(
                                  (manager) =>
                                    parseInt(manager.ManagementLevel, 10) > 2
                                )
                                .map((manager) => (
                                  <option key={manager.id} value={manager.Name}>
                                    {manager.Name} - {manager.Role} - {manager.ManagementLevel}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                       
                        
                        <button onClick={() => handleDeleteTeam(department.id)}  className="rounded-lg bg-red-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-red-500">
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
